"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ShipStationOrderItem = require('./ShipStationOrderItem');

var ShineProducts = require('../../products');

var ShineCatalog = require('../../catalog');

function parseOrderDetails(_ref) {
  var products = _ref.products,
      sales_channel = _ref.sales_channel;
  var _ShineProducts$instan = ShineProducts.instance().constants,
      SILK_RIBBON = _ShineProducts$instan.SILK_RIBBON,
      SILK_RIBBON_SAMPLES = _ShineProducts$instan.SILK_RIBBON_SAMPLES,
      VELLUM_JACKETS = _ShineProducts$instan.VELLUM_JACKETS,
      WAX_SEALS = _ShineProducts$instan.WAX_SEALS;
  var items = [];
  var spl_count = 0;

  if (products) {
    items = products.map(function (product) {
      var catalogEntry = ShineCatalog.instance().getProductCatalogInformation(product);
      var subtotal = product.subtotal;
      var item = new ShipStationOrderItem(_objectSpread(_objectSpread({}, product), {}, {
        name: catalogEntry.name || product.product_type,
        sku: "SKU_".concat(catalogEntry.pid),
        imageUrl: catalogEntry.images[0],
        unitPrice: subtotal,
        weight: {
          value: product.weight,
          units: 'ounces'
        }
      }));

      if (product.product_type.match(/sample/i) || ['fb_promo', 'web_promo', 'fb_lead'].includes(sales_channel)) {
        if (product.product_type === SILK_RIBBON_SAMPLES) {
          item.sku = ('RibbonSample-' + product.ribbonSamples.first().ribbon_spool_color).replace(' ', '');
          item.name = "".concat(product.ribbonSamples.first().ribbon_spool_color, " Ribbon");
        } else if (product.product_type === SILK_RIBBON) {
          item.sku = ('RibbonSpool-' + product.ribbonSpools.first().ribbon_spool_color).replace(' ', '');
          item.name = "".concat(product.ribbonSpools.first().ribbon_spool_color, " Ribbon Spool");
        } else if (product.paidClassicInvitationSamples && product.paidClassicInvitationSamples.collection && product.paidClassicInvitationSamples.collection.length > 0) {
          item.sku = product.design_name + '_SPL';
          item.name = "".concat(product.design_name, " Wedding Invitations - Sample Kit");
          item.weight = {
            units: 'ounces',
            value: spl_count > 0 ? 1 : 6
          };
          spl_count += 1;
        } else if (product.paidLetterpressInvitationSamples && product.paidLetterpressInvitationSamples.collection && product.paidLetterpressInvitationSamples.collection.length > 0) {
          item.sku = product.design_name + '_SPL';
          item.name = "".concat(product.design_name, " Letterpress Wedding Invitations - Sample Kit");
          item.weight = {
            units: 'ounces',
            value: spl_count > 0 ? 1 : 6
          };
          spl_count += 1;
        } else {
          // assume free sample
          item.sku = product.design_name + '_SPL';
          item.name = "".concat(product.design_name);
          item.weight = {
            units: 'ounces',
            value: spl_count > 0 ? 1 : 6
          };
          spl_count += 1;
        }

        if (!(product.quantity && parseInt(product.quantity, 10) > 0)) {
          item.quantity = 1;
        }
      } else if (product.product_type === SILK_RIBBON) {
        item.sku = ('RibbonSpool-' + product.ribbonSpools.first().ribbon_spool_color).replace(' ', '');
        item.name = "".concat(product.ribbonSpools.first().ribbon_spool_color, " Ribbon Spool");
        item.quantity = parseInt(product.ribbonSpools.first().quantity, 10);
        item.unitPrice = parseFloat(subtotal, 10) / item.quantity || 0; // unit price needs to be adjusted
      } else if (product.product_type === VELLUM_JACKETS) {
        item.quantity = parseInt(product.vellumJackets.first().quantity, 10);
        item.unitPrice = parseFloat(subtotal, 10) / item.quantity || 0; // unit price needs to be adjusted

        item.weight.value = parseFloat(product.weight, 10) / item.quantity || 0; // weight needs to be adjusted
      } else if (product.product_type === WAX_SEALS) {
        item.quantity = parseInt(product.waxSeals.first().quantity, 10);
        item.unitPrice = parseFloat(subtotal, 10) / item.quantity || 0; // unit price needs to be adjusted

        item.weight.value = parseFloat(product.weight, 10) / item.quantity || 0; // weight needs to be adjusted
      } else if (product.product_type.match(/reprint/i)) {
        if (product.design_name.match(/reprint/i)) {
          item.name = product.product_type;
        } else {
          item.name = "".concat(product.design_name, " ").concat(product.product_type);
        }
      } // make sure values exist...
      // this is for packages coming from the database that aren't formatted exactly like brand new packages


      if (Number.isNaN(item.weight.value)) {
        item.weight.value = 0;
      }

      if (!item.unitPrice && item.subtotal) {
        item.unitPrice = item.subtotal;
      }

      if (!item.name || item.name === '') {
        item.name = item.product_type;
      }

      return item;
    });
  }

  return items;
}

module.exports = parseOrderDetails;